window.basicDefinition = {
  height: {
    attachments: {
      minHeight: 27,
      maxHeight: 276
    },
    hyperlink: 20,
    control: 20,
    multiLine: 6,
    label: 22,
    labelabove: 26,
    hansenView: 15,
    toolbar: 39,
    module: 28,
    banner: 62,
    menu: 39,
    fieldset: 33,
    tabset: 27,
    grid: {
      footer: 24,
      toolbar: 34,
      title: 33,
      row: 26,
      padding: 0.5
    },
    scrollbar: 10,
    tree: 3,
    myInfor: 47,
    richText: {
      enabled: 27,
      disabled: 12,
      followedge: 27,
      followedgedisabled: 34,
      padding: 4
    },
    modalDiv: {
      maxPercentage: 0.75,
      min: 300,
      padding: 0,
      fullscreenThreshold: 0.6
    }
  },
  width: {
    time: {
      military: 50,
      civil: 70,
      civilOffset: 10
    },
    validate: 12,
    fieldset: 22,
    scrollbar: 10,
    splitter: 10,
    applicationPadding: 40,
    tree: 18,
    multiline: 4,
    multilinelabelabove: 0,
    dropDownBox: {
      padding: 19,
      requiredNoLabel: 5
    },
    richText: {
      toolbar: 0,
      input: 2,
      followedge: 2
    },
    ipsTilePanel: {
      item: 24,
      container: 6
    },
    modalDiv: {
      maxPercentage: 0.9,
      min: 300,
      padding: 55,
      fullscreenThreshold: 0.5
    },
    attachments: {
      collapseWidth: 22
    },
    // used during the calculation of the input sizes for textbox and dropdownbox and label
    inputbox: {
      paddingNoLabel: 10,
      singleLine: 2,
      infoViewer: {
        padding: 14
      },
      hasPopup: 3,
      labelOffset: {
        multiLine: 6,
        singleLine: 8
      },
      required: 8
    }
  },
  top: {
    richText: {
      enabled: 0
    }
  }
};
